
import {Component, Mixins, Prop} from "vue-property-decorator";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";

//<paz-tooltip-text tooltip="this is the tooltip">The text here</paz-tooltip-text>
@Component
export default class PazTooltipText extends Mixins(PermissionService) {

  @Prop({default: ''})
  public tooltip!: string;

  @Prop({default: ''})
  public requiredProfileFlag!: string;

  get getToopTip() {
    if (this.hasRequiredPermission) {
      return this.tooltip;
    }
    return 'NO PERMISSION!';
  }

  get hasRequiredPermission(): boolean {
    if (this.requiredProfileFlag == '') {
      return true;
    }
    return this.hasProfileFlag(this.requiredProfileFlag);
  }

  get devToopTip() {
    return `Required flag: '${this.requiredProfileFlag}'`
  }

}
